import React from 'react';
import { PhoneButton } from 'dyl-components';
import { Grid } from 'semantic-ui-react';

const ListenWhisperBargeButtons = ({
    actionButtons,
    onListen,
    onWhisper,
    onBarge
 }) => {
    const { listen, whisper, barge } = actionButtons || {};
    const getButtonState = (type) => {
        return type ? { isClicked: true, iconColor: 'primary' } : {}
    }
    return (
        <Grid className={`OfficeViewActionButtons`} columns="equal">
            <Grid.Row columns={3}>
                <Grid.Column>
                    <PhoneButton text="Listen" icon="fa-solid fa-ear-listen" onClick={onListen} {...getButtonState(listen)} />
                </Grid.Column>
                <Grid.Column>
                    <PhoneButton text="Whisper" icon="fa-solid fa-user-headset" onClick={onWhisper} isClicked={whisper} {...getButtonState(whisper)} />
                </Grid.Column>
                <Grid.Column>
                    <PhoneButton text="Barge" icon="fa-solid fa-bullhorn" onClick={onBarge} isClicked={barge} {...getButtonState(barge)} />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    )
};

export default ListenWhisperBargeButtons;
